import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { useNavigate, Outlet } from 'react-router-dom';
import {
  Row, Col, Form, Button,
} from 'react-bootstrap5';

import routes from 'app/routes';
import StepTab from 'components/new_ui/Tabs/StepTab';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import Steps from 'components/Members/Programs/Widgets/Steps/Index';

import { useContext } from 'components/Members/Programs/Views/Show/Context';

import Alert from 'components/new_ui/Alerts/alert';

import { useContext as useHomeContext } from 'components/Members/Home/Context';
import Breadcrumbs from 'components/new_ui/Breadcrumbs/Index';

export default function Index({ showSteps }) {
  const navigate = useNavigate();

  const { dispatch, actions, state } = useContext();

  const [loading, setLoading] = useState(false);
  const [programTitle, setProgramTitle] = useState(state.program.attributes.title);

  const homeContext = useHomeContext();

  const breadcrumbs = [
    {
      name: 'Home',
      path: '/members/home',
    },
    {
      name: 'Programs',
      path: routes.members.programs.index,
    },
    {
      name: 'New Program',
    },
  ];

  const updateProgramTitle = () => {
    if (programTitle === '') {
      Alert({
        text: 'Please enter a title for your program',
      });
      return;
    }
    setLoading(true);

    actions.updateTitle(dispatch, state.program.id, programTitle, () => {
      setLoading(false);

      navigate(routes.members.programs.new_ai.confirm(state.program.id));
    });
  };

  return (
    <>
      {showSteps && (
      <StepTab
        total={3}
        current={2}
      />
      )}

      <div className="content">
        {homeContext && <Breadcrumbs breadcrumbs={breadcrumbs} />}
        <section>
          <h1 className="mb-3">Your Recommended Program</h1>

          <p>
            Your personalized Talent Insurance Program is tailored to your
            unique journey and goals, handpicked based on the results of your
            Talent Assessment.
          </p>

          <p>
            We&apos;ve analyzed your productivity and wellbeing dimensions to provide
            you with expert resources that foster career growth and life balance.
          </p>

          <p>
            If you wish to explore different topics, you can simply click the
            &ldquo;Change Topic&rdquo; button and discover a wide array of additional topics
            from the LeggUP Topic Library.
          </p>
        </section>

        <section>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>
                  Program Name
                  <abbr className="ms-2" title="required">*</abbr>
                </Form.Label>

                <Form.Control
                  defaultValue={state.program.attributes.title}
                  placeholder="Program Name"
                  onChange={(e) => setProgramTitle(e.target.value)}
                  disabled={loading}
                />
              </Form.Group>
            </Col>

          </Row>

          <Row className="mt-5">
            <Col lg={{ span: 8, offset: 2 }}>
              <Steps steps={state.program.attributes.steps} />
            </Col>
          </Row>
        </section>

        <footer>
          <Button
            onClick={() => updateProgramTitle()}
            disabled={loading}
          >
            {loading && <LoadingPlaceholder placement="inline" text=" " />}
            Next
          </Button>
        </footer>
      </div>

      <Outlet />
    </>
  );
}

Index.propTypes = {
  showSteps: PropTypes.bool,
};

Index.defaultProps = {
  showSteps: true,
};
